import Div from "@jumbo/shared/Div";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import WorkflowApproverStatus from "app/shared/ReuseComponents/WorkflowApproverStatus";
import React, { useEffect, useState } from "react";
import { MdClose } from "react-icons/md";
import * as XLSX from "xlsx";
import DesktopTimesheetTable from "./DesktopTimesheetTable";
import MobileTimesheetCards from "./MobileTimesheetCards";

const TimeManagementDocumentApproval = ({
  openViewRequest,
  setOpenViewRequest,
  value,
  handleChange,
  requests,
  approvalStatus,
  updateHistory,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const headApproverName = localStorage.getItem("ReportHeadName");
  const partnerId = parseInt(localStorage.getItem("PartnerId"));
  const WorkflowName = "timesheet";

  console.log("approvalStatus", approvalStatus);

  const [openRows, setOpenRows] = useState([]);

  const toggleOpen = (index) => {
    const newExpandedRows = [...openRows]; //[5]
    if (newExpandedRows.includes(index)) {
      newExpandedRows.splice(newExpandedRows.indexOf(index), 1);
    } else {
      newExpandedRows.push(index);
    }
    setOpenRows(newExpandedRows);
  };


  const getStatus = (data) => {
    if (data?.Approved_Flag === true && data?.Status === true) {
      return (
        <Typography
          color="success"
          variant="h6"
          sx={{ width: "110px", cursor: "default", color: "#3BD2A2" }}
        >
          Approved
        </Typography>
      );
    } else if (data?.Approved_Flag === false && data?.Status === true) {
      return (
        <Typography
          variant="h6"
          sx={{ width: "110px", cursor: "default", color: "red" }}
        >
          Rejected
        </Typography>
      );
    } else if (data?.Approved_Flag === false && data?.Status === false) {
      return (
        <Typography
          variant="h6"
          sx={{
            width: "110px",
            cursor: "default",
            color: data?.Timesheet_flg === "Submitted" ? "#017890" : "#F39711",
          }}
        >
          {/* Pending */}
          {data?.Timesheet_flg}
        </Typography>
      );
    }
  };

  useEffect(() => {
    if (!requests?.length) return;

    const allKeys = [];

    requests?.forEach((timesheet, sheetIndex) => {
      timesheet?.Timemanagement?.forEach((_, dayIndex) => {
        allKeys.push(`${sheetIndex}-${dayIndex}`);
      });
    });

    setOpenRows(allKeys);
  }, [requests]);

  const downloadExcel = () => {
    if (!requests?.length) return;

    const excelData = [];

    requests.forEach((timesheet) => {
      timesheet?.Timemanagement?.forEach((dayData) => {
        // Main row
        excelData.push({
          Date: dayData?.date,
          "Employee Code": timesheet?.Employee_Id?.Employee_Id,
          "Employee Name": `${timesheet?.Employee_Id?.Employee_FirstName || ""} ${timesheet?.Employee_Id?.Employee_LasttName || ""}`,
          "Timesheet Name": timesheet?.Timesheet_Name,
          "From Time": dayData?.fromTime,
          "To Time": dayData?.toTime,
          "Task Type": "",
          "Task Description": "",
          "Total Time": dayData?.totalTime,
          Status: timesheet?.Timesheet_flg,
        });

        // Expanded task rows
        dayData?.taskCarried?.forEach((task) => {
          excelData.push({
            Date: "",
            "Employee Code": "",
            "Employee Name": "",
            "Timesheet Name": "",
            "From Time": "",
            "To Time": "",
            "Task Type": task?.taskType,
            "Task Description": task?.task,
            "Total Time": task?.hours,
            Status: "",
          });
        });
      });
    });

    // const worksheet = XLSX.utils.json_to_sheet(excelData);

    // 👉 Create empty worksheet (NO auto header)
    const worksheet = XLSX.utils.json_to_sheet([], { skipHeader: true });

    // 👉 Header row
    const headers = Object.keys(excelData[0]);

    // Add header at row 1
    XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A1" });

    // 👉 Empty row gap at row 2
    XLSX.utils.sheet_add_aoa(worksheet, [[]], { origin: "A2" });

    // 👉 Data starts from row 3
    XLSX.utils.sheet_add_json(worksheet, excelData, {
      origin: "A3",
      skipHeader: true,
    });

    // 👉 Bold header
    headers.forEach((_, index) => {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: index });
      if (worksheet[cellAddress]) {
        worksheet[cellAddress].s = {
          font: { bold: true },
          alignment: { vertical: "center" },
        };
      }
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Timesheet");

    XLSX.writeFile(workbook, "Timesheet_Report.xlsx");
  };

  console.log("timesheetLists", requests);

  return (
    <Dialog maxWidth="lg" fullWidth open={openViewRequest}>
      <DialogTitle
        sx={{ display: "flex", justifyContent: "space-between", mb: -2 }}
      >
        <Div sx={{ fontSize: "18px" }}>View Timesheet</Div>
        <IconButton onClick={() => setOpenViewRequest(false)}>
          <MdClose />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <TabContext value={value}>
          <Box
            // sx={{
            //   display: "flex",
            //   justifyContent: "space-between",
            //   alignItems: "center",
            //   borderBottom: 0,
            //   borderColor: "divider",
            // }}

            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: 2,
              justifyContent: "space-between",
              alignItems: { xs: "stretch", sm: "center" },
            }}
          >
            <TabList onChange={handleChange} aria-label="tabs">
              <Tab
                label="Overview"
                value="1"
                sx={{ fontSize: "16px", color: "#000000" }}
              />
            </TabList>
            <Button variant="contained" color="success" onClick={downloadExcel}>
              Download Excel
            </Button>
          </Box>

          {/* ========== Overview Panel ========== */}
          <TabPanel value="1" sx={{ p: 0, pt: 2 }}>
            {requests?.length > 0 ? (
              <>
                {isMobile ? (
                  <MobileTimesheetCards
                    timesheetLists={requests}
                    openRows={openRows}
                    toggleOpen={toggleOpen}
                    getStatus={getStatus}
                  />
                ) : (
                  <DesktopTimesheetTable
                    isMobile={isMobile}
                    timesheetLists={requests}
                    openRows={openRows}
                    toggleOpen={toggleOpen}
                    getStatus={getStatus}
                  />
                )}
              </>
            ) : (
              <>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="h5">Timesheet Id</Typography>
                    <Typography variant="h5">Timesheet Name</Typography>
                    <Typography variant="h5">Employee Name</Typography>
                    <Typography variant="h5">Timesheet Month</Typography>
                    <Typography variant="h5">From Date</Typography>
                    <Typography variant="h5">To Date</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <Typography variant="h5">
                      : {requests?.TimeSheet_Id}
                    </Typography>
                    <Typography variant="h5">
                      : {requests?.Timesheet_Name}
                    </Typography>
                    <Typography variant="h5">
                      : {requests?.Employee_Id?.Employee_FirstName}{" "}
                      {requests?.Employee_Id?.Employee_LasttName} -{" "}
                      {requests?.Employee_Id?.Employee_Id}
                    </Typography>
                    <Typography variant="h5">: {requests?.Month}</Typography>
                    <Typography variant="h5">: {requests?.FromDate}</Typography>
                    <Typography variant="h5">: {requests?.ToDate}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3}>
                    <Box>
                      {requests?.Approved_Flag === true &&
                      requests?.Status === true ? (
                        <img
                          src="./../../../../../images/StatusFlg/Approved.png"
                          width={150}
                          height={70}
                          alt="Approved"
                        />
                      ) : requests?.Approved_Flag === false &&
                        requests?.Status === true ? (
                        <img
                          src="./../../../../../images/StatusFlg/Rejected.png"
                          width={150}
                          height={70}
                          alt="Rejected"
                        />
                      ) : (
                        <img
                          src="./../../../../../images/StatusFlg/Pending.png"
                          width={150}
                          height={70}
                          alt="Pending"
                        />
                      )}
                    </Box>
                  </Grid>
                </Grid>

                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Box mt={5}>
                      <Typography variant="h5" fontWeight={600}>
                        Time Management Details
                      </Typography>

                      {/* {requests?.Timemanagement?.length > 0 ? (
                                        requests?.Timemanagement.map((entry, index) => (
                                            <Box
                                                key={index}
                                                sx={{
                                                    border: "1px solid #e0e0e0",
                                                    borderRadius: "10px",
                                                    padding: "20px",
                                                    mb: 3,
                                                    backgroundColor: "#fafafa",
                                                    boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
                                                }}
                                            >
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={6} md={3}>
                                                        <Typography variant="subtitle2" color="text.secondary">
                                                            Date
                                                        </Typography>
                                                        <Typography variant="body1">{entry.date || "-"}</Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={3}>
                                                        <Typography variant="subtitle2" color="text.secondary">
                                                            From Time
                                                        </Typography>
                                                        <Typography variant="body1">{entry.fromTime || "-"}</Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={3}>
                                                        <Typography variant="subtitle2" color="text.secondary">
                                                            To Time
                                                        </Typography>
                                                        <Typography variant="body1">{entry.toTime || "-"}</Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={3}>
                                                        <Typography variant="subtitle2" color="text.secondary">
                                                            Total Time (hrs)
                                                        </Typography>
                                                        <Typography variant="body1">{entry.totalTime || "-"}</Typography>
                                                    </Grid>
                                                </Grid>

                                                <Box mt={3}>
                                                    <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                                        Tasks Carried
                                                    </Typography>
                                                    {entry?.taskCarried?.length > 0 ? (
                                                        <Grid container spacing={1}>
                                                            {entry.taskCarried.map((task, taskIndex) => (
                                                                <Grid item xs={12} key={taskIndex}>
                                                                    <Typography variant="body2">
                                                                        <strong>{task.taskType}</strong>: {task.task || "No Description"} -{" "}
                                                                        <strong>{task.hours} hrs</strong>
                                                                    </Typography>
                                                                </Grid>
                                                            ))}
                                                        </Grid>
                                                    ) : (
                                                        <Typography variant="body2" color="text.secondary">
                                                            No tasks recorded.
                                                        </Typography>
                                                    )}
                                                </Box>
                                            </Box>
                                        ))
                                    ) : (
                                        <Typography variant="body2" color="text.secondary">
                                            No time management data available.
                                        </Typography>
                                    )} */}

                      {requests?.Timemanagement?.length > 0 ? (
                        <TableContainer sx={{ mt: 2 }}>
                          <Table stickyHeader className="table">
                            <TableHead className="table-head">
                              <TableRow>
                                <TableCell>
                                  <strong>Date</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>From Time</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>To Time</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Total Time (hrs)</strong>
                                </TableCell>
                                <TableCell>
                                  <strong>Tasks Carried</strong>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {requests.Timemanagement.map((entry, index) => (
                                <TableRow key={index}>
                                  <TableCell>{entry.date || "-"}</TableCell>
                                  <TableCell>{entry.fromTime || "-"}</TableCell>
                                  <TableCell>{entry.toTime || "-"}</TableCell>
                                  <TableCell>
                                    {entry.totalTime || "-"}
                                  </TableCell>
                                  <TableCell>
                                    {entry?.taskCarried?.length > 0 ? (
                                      <ul
                                        style={{ paddingLeft: 16, margin: 0 }}
                                      >
                                        {entry.taskCarried.map(
                                          (task, taskIndex) => (
                                            <li key={taskIndex}>
                                              <Typography variant="body2">
                                                <strong>{task.taskType}</strong>
                                                :{" "}
                                                {task.task || "No Description"}{" "}
                                                -{" "}
                                                <strong>
                                                  {task.hours} hrs
                                                </strong>
                                              </Typography>
                                            </li>
                                          ),
                                        )}
                                      </ul>
                                    ) : (
                                      <Typography
                                        variant="body2"
                                        color="text.secondary"
                                      >
                                        No tasks recorded.
                                      </Typography>
                                    )}
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      ) : (
                        <Typography variant="body2" color="text.secondary">
                          No time management data available.
                        </Typography>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </>
            )}

            <Box mt={3}>
              <WorkflowApproverStatus
                WorkflowName={WorkflowName}
                partnerId={partnerId}
                approvalStatus={approvalStatus?.Approve}
                HeadApproverName={headApproverName}
              />
            </Box>
          </TabPanel>
        </TabContext>
      </DialogContent>
    </Dialog>
  );
};

export default TimeManagementDocumentApproval;
